export const styles = {
	select:
		'rounded-md border border-subtle bg-white px-xs py-2xs pr-lg text-[13px] text-default appearance-none bg-no-repeat focus:border-action-primary focus:outline-none focus:ring-2 focus:ring-action-primary/15',
};
